interface AnnouncementNavLabelProps {
  isNew: boolean;
  /** 初回meta取得中だけ幅を予約し、既読・失敗確定後は予約を解除する。 */
  reserveNewBadge?: boolean;
}

/**
 * NEWは可視テキストとしてリンク名に含める。色だけに依存せず、
 * スクリーンリーダーにも「告知 NEW」として伝わる。
 */
export const AnnouncementNavLabel: React.FunctionComponent<
  AnnouncementNavLabelProps
> = ({ isNew, reserveNewBadge = false }: AnnouncementNavLabelProps) => {
  return (
    <span className="inline-flex items-center gap-2">
      告知
      {(isNew || reserveNewBadge) && (
        <strong
          aria-hidden={isNew ? undefined : true}
          className={`rounded border border-primary px-1.5 py-0.5 text-xs font-bold leading-none text-primary${isNew ? "" : " invisible"}`}
        >
          NEW
        </strong>
      )}
    </span>
  );
};
